export const TOGGLE_CAT = 'elements'
export const TOGGLE_LIST_ITEM_CAT = 'listElements'
export const IMAGE_ASPECT_CATEGORY = 'layout'
